import React from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { I18nProvider } from "@/context/I18nContext";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { Home } from "@/pages/Home";
import { ManagedSecurity } from "@/pages/services/ManagedSecurity";
import { ManagedBackup } from "@/pages/services/ManagedBackup";
import { ManagedServer } from "@/pages/services/ManagedServer";
import { Schwachstellen } from "@/pages/services/Schwachstellen";
import { ManagedWlan } from "@/pages/services/ManagedWlan";
import { Webdesign } from "@/pages/services/Webdesign";
import { ManagedServices } from "@/pages/services/ManagedServices";
import Ueberwachungskameras from "@/pages/services/Ueberwachungskameras";
import LokaleKI from "@/pages/services/LokaleKI";
import ItDienstleister from "@/pages/ItDienstleister";
import { WebsiteCheck } from "@/pages/WebsiteCheck";
import { Kontakt } from "@/pages/Kontakt";
import { Blog, BlogPost } from "@/pages/Blog";
import { Impressum, Datenschutz } from "@/pages/Legal";
import { AdminLogin } from "@/pages/admin/AdminLogin";
import { AdminApp } from "@/pages/admin/AdminApp";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/managed-security" element={<ManagedSecurity />} />
                <Route path="/managed-backup" element={<ManagedBackup />} />
                <Route path="/managed-backup-and-recovery" element={<Navigate to="/managed-backup" replace />} />
                <Route path="/managed-server" element={<ManagedServer />} />
                <Route path="/managed-server-hosting" element={<Navigate to="/managed-server" replace />} />
                <Route path="/schwachstellenmanagement" element={<Schwachstellen />} />
                <Route path="/managed-wlan" element={<ManagedWlan />} />
                <Route path="/managed-wlan-basic" element={<Navigate to="/managed-wlan" replace />} />
                <Route path="/webdesign" element={<Webdesign />} />
                <Route path="/managed-services" element={<ManagedServices />} />
                <Route path="/ueberwachungskameras" element={<Ueberwachungskameras />} />
                <Route path="/videoueberwachung" element={<Navigate to="/ueberwachungskameras" replace />} />
                <Route path="/lokale-ki" element={<LokaleKI />} />
                <Route path="/ki" element={<Navigate to="/lokale-ki" replace />} />
                <Route path="/eigene-ki" element={<Navigate to="/lokale-ki" replace />} />
                <Route path="/ki-im-unternehmen" element={<Navigate to="/lokale-ki" replace />} />
                <Route path="/it-dienstleister" element={<ItDienstleister />} />
                <Route path="/it-service" element={<Navigate to="/it-dienstleister" replace />} />
                <Route path="/it-berater" element={<Navigate to="/it-dienstleister" replace />} />
                <Route path="/it-beratung" element={<Navigate to="/it-dienstleister" replace />} />
                <Route path="/webseiten-check" element={<WebsiteCheck />} />
                <Route path="/website-check" element={<Navigate to="/webseiten-check" replace />} />
                <Route path="/seo-check" element={<Navigate to="/webseiten-check" replace />} />
                <Route path="/webentwicklung" element={<Navigate to="/webdesign" replace />} />
                <Route path="/web-design" element={<Navigate to="/webdesign" replace />} />
                <Route path="/seo" element={<Navigate to="/webdesign" replace />} />
                <Route path="/kontakt" element={<Kontakt />} />
                <Route path="/contact" element={<Navigate to="/kontakt" replace />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/impressum" element={<Impressum />} />
                <Route path="/datenschutz" element={<Datenschutz />} />
                <Route path="/admin/login" element={<AdminLogin />} />
              </Route>
              <Route path="/admin/*" element={<AdminApp />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </I18nProvider>
    </HelmetProvider>
  );
}

export default App;
